import { render, staticRenderFns } from "./TableRiskAppraisalNHSafe.vue?vue&type=template&id=ec6ae020&scoped=true"
import script from "./TableRiskAppraisalNHSafe.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalNHSafe.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalNHSafe.vue?vue&type=style&index=0&id=ec6ae020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6ae020",
  null
  
)

export default component.exports